// Copyright (c) 2022 by Move Closer

import { ModuleContentResolver } from '../../contexts'

import { abstractModuleContentResolver } from '../abstract/abstract-resolver'
import { AccordionModuleContent, AccordionModuleContentInput } from './Accordion.contracts'

/**
 * @author Katarzyna Otto <katarzyna.otto@movecloser.pl> (original)
 */
export const resolveAccordionModuleContent: ModuleContentResolver<AccordionModuleContentInput, AccordionModuleContent> =
  abstractModuleContentResolver
